import { render, staticRenderFns } from "./VersionModalAddress.vue?vue&type=template&id=276d1152&scoped=true"
import script from "./VersionModalAddress.vue?vue&type=script&lang=js"
export * from "./VersionModalAddress.vue?vue&type=script&lang=js"
import style0 from "./VersionModalAddress.vue?vue&type=style&index=0&id=276d1152&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276d1152",
  null
  
)

export default component.exports